"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTitleRenderer = exports.ModalTitle = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _context = require("../context");

var _text = require("../text");

var _utils = require("../utils");

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ModalTitleBase = (0, _context.styledWithTheme)(_text.Text.withComponent('h2', {
  target: "e43fm170"
}))(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    paddingRight: (0, _utils.px)(selectors.space('S400'))
  };
});
var ModalTitle = (0, _utils.withTestAttributes)({
  component: 'StencilModalTitle'
})(ModalTitleBase);
exports.ModalTitle = ModalTitle;
ModalTitle.defaultProps = _objectSpread(_objectSpread({}, (0, _utils.omit)(_text.Text.defaultProps, ['ref'])), {}, {
  fontSize: 'T500',
  fontWeight: 'regular',
  margin: 0
});
ModalTitle.displayName = 'ModalTitle';

var defaultTitleRenderer = function defaultTitleRenderer(_ref2) {
  var id = _ref2.id,
      titleText = _ref2.titleText;
  return (0, _core.jsx)(ModalTitle, {
    id: id
  }, titleText);
};

exports.defaultTitleRenderer = defaultTitleRenderer;